import React from "react";
import "./welcome.css";
import image from "../dashboard/mainsss.png";
import { useSelector } from "react-redux";

const adminPowers = [
  "Create/Update/Remove new Subjects",
  "Create/Remove/Update Teacher's Data",
];

const teacherPowers = [
  "Create/Update/Remove Questions",
  "Create Test Papers from the created questions",
  "Performance analysis of the students",
  "Get the list of students who have attempted the test",
  "Control the start and end time for the test",
  "Send Test Paper's link (test ID) to the students",
];

const studentPowers = [
  "Attempt the test papers",
  "View the results and Paper Analysis",
  "Give Feedback to the teacher",
];

const Welcome = () => {
  const user = useSelector((state) => state.auth);
  //  console.log(user);
  

  if (!user.isLoggedIn) {
    return <div className="welcome_main_container"></div>;
  }

  const { type, name, emailid, contact } = user.user;

  const powers =
    type === "ADMIN"
      ? adminPowers
      : type === "TRAINER"
      ? teacherPowers
      : studentPowers;

  const typeToShow =
    type === "TRAINER" ? "TEACHER" : type === "ADMIN" ? "ADMIN" : "STUDENT";

  return (
    <div className="welcome_main_container">
      <div className="welcome_left">
        <h1>Name: {name}</h1>
        <h2>Email: {emailid}</h2>
        <h2>Contact: {contact}</h2>
        <h2>Logged In As: {typeToShow}</h2>

        <br />
        <div className="admin_powers">
          <h2>What you can do as {typeToShow}:</h2>
          <ul>
            {powers.map((power, index) => (
              <li key={index}>{power}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="welcome_right">
        <img src={image} alt="img" />
        <h1>Examination Portal</h1>
      </div>
    </div>
  );
};

export default Welcome;
